import DividerWithText from './DividerWithText';
export default DividerWithText;
